import React, { useContext, useMemo, type PropsWithChildren } from "react";

import { MemoryStorage, StorageAdapter } from "@repo/utils/lib";

interface Context {
  memory: StorageAdapter;
  session: StorageAdapter;
  storage: StorageAdapter;
}

export const StorageContext = React.createContext<Context>({} as Context);
export function useStorageContext(): Context {
  return useContext(StorageContext);
}

export const STORAGE_KEY = {
  PREFS: "prefs",
  TENANT: "tenant",
  LOGIN_HINT: "loginHint",
  REMEMBER_ME: "rememberMe",
} as const;

export type STORAGE_KEY = (typeof STORAGE_KEY)[keyof typeof STORAGE_KEY];

/**
 * Storage provider to provide storage adapters
 * @param props
 * @returns
 */
export const StorageProvider: React.FC<
  PropsWithChildren<{
    namespace: string;
  }>
> = ({ namespace, children }) => {
  const memory = useMemo(
    () => new StorageAdapter(namespace, new MemoryStorage()),
    [namespace],
  );
  const storage = useMemo(
    () => new StorageAdapter(namespace, window.localStorage),
    [namespace],
  );
  const session = useMemo(
    () => new StorageAdapter(namespace, window.sessionStorage),
    [namespace],
  );

  return (
    <StorageContext.Provider
      value={{
        memory,
        storage,
        session,
      }}
    >
      {children}
    </StorageContext.Provider>
  );
};
